import { HomePage } from "@features/home/ui/HomePage.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/home")({
  component: HomePage,
});
